import React, { useEffect, useState, useCallback, useRef } from "react";
// Reusable components ------------------------------------
import AnnouncementType from "./AnnouncementType";
import AnnouncemntTemplate from "./AnnouncemntTemplate";
import LivePreview from "./LivePreview";
import QuickStatus from "./QuickStatus";
// third party library ------------------------------------
import { Col, Form, Row } from "react-bootstrap";
import ReactQuill from "react-quill";
import { useDropzone } from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import Switch from "@mui/material/Switch";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { HexColorPicker } from "react-colorful";
import Select from "react-select";
// icons --------------------------------------------------
import { FiPlus } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaImage } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoEyeOutline } from "react-icons/io5";
import { FaCamera } from "react-icons/fa6";
import { AiFillDislike } from "react-icons/ai";
import { FaThumbsUp } from "react-icons/fa6";
import { BsChatFill } from "react-icons/bs";
import { FaReply } from "react-icons/fa6";
import { PiPencilSimpleLine } from "react-icons/pi";
import { FaSave } from "react-icons/fa";
import { GrSend } from "react-icons/gr";
import { FaFileLines } from "react-icons/fa6";
import birthday from "../../assets/icons/🎂.png"
import onbording from "../../assets/icons/👋.png"
import sales from "../../assets/icons/🚀.png"
// Services -----------------------------------------
import { imageToBase64 } from "../../services/commonServices";
// Redux --------------------------------------------
import { ancemntSaveData, ancemntSaveDataOne, ancemntGetData, ancemntGetDataOne, ancemntGetDataThird, ancemntGetDataFourth, initAncemntState, getAnnouncementTitle, initAncmtTitleState } from "../../redux/slices/announcementSlice";
import { createAnnouncementTypePath, updateAnnouncementTypePath, announceEmpListPath, announceEmpGroupPath, getDepartmentListPath, saveAnnouncementPath, recentDraftListPath, getAnnouncementTitlePath } from "../../services/config";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftLong } from "../../components/icons/Icons";
import { useNavigate } from "react-router-dom";

const AddNotification = () => {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem("user_data")) || {}

  const dispatch = useDispatch()
  const announceStore = useSelector((state) => state.announce)
  const themeStore = useSelector((state) => state.theme)

  const containerRef = useRef(null);
  const [announcementType, setAnnouncementType] = useState(""); console.log("announcementType >--------->", announcementType)
  const [announcementTypeIcon, setAnnouncementTypeIcon] = useState("");
  const [value, setValue] = useState("");
  const [descriptionCount, setDescriptionCount] = useState(0);
  const MAX_SIZE = 10 * 1024 * 1024; // 10 MB
  const [files, setFiles] = useState([]);
  const [taggedEmpList, setTaggedEmpList] = useState([]);
  const [taggedEmpGroupList, setTaggedEmpGroupList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [usedSize, setUsedSize] = useState(0);
  const [createAnnType, setCreateAnnType] = useState(false);
  const [isEditAnnType, setIsEditAnnType] = useState(false);
  const [isEditAnnTypeSuccess, setIsEditAnnTypeSuccess] = useState(false);
  const [validated, setValidated] = useState(false);
  const [annTypeSubject, setAnnTypeSubject] = useState("");
  const [annTypeDataObj, setAnnTypeDataObj] = useState({
    announcementTitleId: "",
    subjectFlag: "",
    bodyContent: "",
    tagPeoples: "",
    tagGroups: "",
    announceBanner: null,
    announceBnrPrev: "",
    reactionAllowId: "",
    reactionDislikeId: "",
    commentId: "",
    repliesId: "",
    approveComments: "",
    allowPushNotify: "",
    pinTopFeed: "",
    allowPublishNowOrLater: "",
    scheduleDate: "",
    scheduleTime: "",
    visiblityId: "",
    departmentId: "",
    isSaveDraft: "",
    attachements: ""
  })
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsGroup, setSelectedOptionsGroup] = useState([]);
  const [selectedTagEmp, setSelectedTagEmp] = useState({
    list: []
  });

  const [selectedTagEmpGroup, setSelectedTagEmpGroup] = useState({
    list: []
  });

  const [color, setColor] = useState("");
  const [colorError, setColorError] = useState(false);
  const [annTypeData, setAnnTypeData] = useState({});


  const [recentDraftList, setRecentDraftList] = useState([]);
  const [announcementTitleList, setAnnouncementTitleList] = useState([]);

  // Get draft list functions are here ------------------
  const getDraftList = useCallback(() => {
    const formData = {
      path: recentDraftListPath,
      data: {
        "userId": user.user_id,
        "isDraft": "1"
      }
    }
    dispatch(ancemntSaveDataOne(formData))
  }, [])

  const handleSetValue = (value) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = value;
    const plainText = tempDiv.textContent || tempDiv.innerText || "";
    setDescriptionCount(plainText.length);

    if (plainText.length < 250) {
      setValue(value)
    }
  }

  const handleAllowLike = (checked) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      reactionAllowId: checked ? "1" : "0"
    }))
  }

  const handleAllowDisLike = (checked) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      reactionDislikeId: checked ? "1" : "0"
    }))
  }

  const handleCommentId = (checked) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      commentId: checked ? "1" : "0"
    }))
  }

  const handleRepliesId = (checked) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      repliesId: checked ? "1" : "0"
    }))
  }

  const handleApprovalCmd = (checked) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      approveComments: checked ? "1" : "0"
    }))
  }

  const handleAllowPushNotify = (checked) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      allowPushNotify: checked ? "1" : "0"
    }))
  }

  const handlePinTopFeed = (checked) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      pinTopFeed: checked ? "1" : "0"
    }))
  }

  const handleAnnouncementTitleId = (value) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      announcementTitleId: value
    }))
  }

  

  const handleChangeTag = (selected) => {
    // Agar kuch select kiya hai to array me set karo, warna empty
    setSelectedOptions(selected || []);
    setSelectedTagEmp((pre) => ({
      ...pre,
      list: [...selectedTagEmp.list, selected]
    }))
  };

  const handleChangeTagGroup = (selected) => {
    // Agar kuch select kiya hai to array me set karo, warna empty
    setSelectedOptions([]);
    // setSelectedOptions(selected || []);
    setSelectedTagEmpGroup((pre) => ({
      ...pre,
      list: [...selectedTagEmpGroup.list, selected]
    }))
  };

  const handleRemoveTagEmp = (value) => {
    // setSelectedTagEmp((prev) => ({
    //   list: prev.list.filter((item) => item.value !== value),
    // }));

    setSelectedTagEmp((prev) => {
      const newList = prev.list.filter((item) => item.value !== value);

      // Agar list empty ho gayi, toh dropdown ka selectedOptions clear karo
      if (newList.length < 1) {
        setSelectedOptions([]);
      }

      return { list: newList };
    });

  };

  const handleAnnTypeInputChange = ({ target: { name, value } }) => {
    setAnnTypeDataObj((pre) => ({
      ...pre,
      [name]: value
    }))
  }


  const getTagEmpList = useCallback(() => {
    const path1 = {
      path: announceEmpListPath,
      data: {
        userId: user.user_id
      }
    }
    const path2 = {
      path: announceEmpGroupPath,
      data: {
        userId: user.user_id
      }
    }

    dispatch(ancemntGetDataThird(path1))
    dispatch(ancemntGetDataFourth(path2))
    dispatch(ancemntGetDataOne(`${getDepartmentListPath}${user.user_id}`))
  }, [])

  useEffect(() => {
    getTagEmpList()
    getDraftList()
  }, [])

  const handleAnnTypeSubject = ({ target: { value } }) => {
    setAnnTypeSubject(value)
  }

  useEffect(() => {
    const container = containerRef.current;

    const handleScroll = () => {
      if (!container) return;

      const windscroll = container.scrollTop;
      const sections = container.querySelectorAll("section");

      sections.forEach((sec, i) => {
        if (sec.offsetTop <= windscroll + 50) {
          document
            .querySelectorAll("ul li a .step-num.active")
            .forEach((el) => el.classList.remove("active"));

          const li = document.querySelectorAll("ul li a .step-num")[i];
          if (li) li.classList.add("active");
        }
      });
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on mount

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const notiHeader = [
    { id: 1, label: "Type", href: "type" },
    { id: 2, label: "Subject", href: "subject" },
    { id: 3, label: "Content", href: "content" },
    { id: 4, label: "Tags", href: "tags" },
    { id: 5, label: "Attach", href: "attach" },
    { id: 6, label: "Settings", href: "settings" },
  ];

  const editorModules = {
    toolbar: [
      ["bold", "italic", "underline"],
      ["link"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };

  const onDrop = useCallback((acceptedFiles) => {
    const newSize = acceptedFiles.reduce((acc, file) => acc + file.size, 0);

    // Check total size
    if (usedSize + newSize > MAX_SIZE) {
      alert("Total size 10MB se zyada nahi ho sakti!");
      return;
    }

    setFiles((prev) => [
      ...prev,
      ...acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      ),
    ]);
    setUsedSize((prev) => prev + newSize);
  }, [usedSize]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    // accept: {
    //   "image/*": [], // sirf images allow
    // },
    accept: {
      "application/*": [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".csv"],
    },
    multiple: true,
    maxSize: 10 * 1024 * 1024, // 5MB
  });

  // 🔹 Remove function
  const removeFile = (name, size) => {
    setFiles((prev) => prev.filter((file) => file.name !== name));
    setUsedSize((prev) => prev - size);
  };

  const uploadEmpPhoto = async (e) => {
    const file = e.target.files[0]
    const base64File = await imageToBase64(file)
    const { name } = e.target

    // setAnnouncementCreate((pre) => ({
    //   ...pre,
    //   [name]: file,
    //   announceBnrPrev: base64File.base64
    // }))

    setAnnTypeDataObj((pre) => {
      const updated = {
        ...pre,
        [name]: file,
        announceBnrPrev: base64File.base64,
      };

      return updated;
    });
  }

  const browseTemplate = (e) => {

  }

  const useTemplate = (data) => {
    console.log("mera data", data)
  }

  const [announcementCreate, setAnnouncementCreate] = useState({
    userId: user.user_id,
    announcementTitleId: "",
    announceId: "",
    announceName: "",
    announceDesc: "",
    announceImage: null,
    announceIcon: "",
    isEnableFile: "1",
  })

  const handleAnnFileChange = async (e) => {
    const base64File = await imageToBase64(e.target.files[0])

    setAnnouncementCreate((pre) => ({
      ...pre,
      [e.target.name]: e.target.files[0],
      announceIcon: base64File.base64
    }))
  };

  const handleColorCode = (color) => {
    setColor(color)
    setColorError(false)
  }

  const handleAnnIsFileEnable = (checked) => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      isEnableFile: checked ? "1" : "0"
    }))
  }

  const handleCreateAnnouncementType = ({ target: { name, value } }) => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const handleAnnouncementTitle = ({ target: { name, value } }) => {
    const title = announcementTitleList.filter((item) => item.announcementTitleId == value)[0].announcementTitleName
    console.log(title)
    setAnnouncementCreate((pre) => ({
      ...pre,
      [name]: value,
      announceName: title
    }))

    
  }

  const handleAnnTypeClicked = (data) => {
    setAnnTypeData(data)
  }

  const submitCreateAnnouncementType = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    const formData = new FormData();

    formData.append("userId", announcementCreate.userId)
    formData.append("announcementTitleId", announcementCreate.announcementTitleId)
    formData.append("announceId", announcementCreate.announceId)
    formData.append("announceName", announcementCreate.announceName)
    formData.append("announceDesc", announcementCreate.announceDesc)
    formData.append("announceImage", announcementCreate.announceImage)
    formData.append("colorCode", color)
    formData.append("isEnableFile", announcementCreate.isEnableFile)

    if (form.checkValidity() === false) {
      setValidated(true);
      if (color == "") {
        setColorError(true)
      }
    } else {
      setColorError(false)
      const form_data = {
        path: isEditAnnType ? updateAnnouncementTypePath : createAnnouncementTypePath,
        data: formData
      }
      dispatch(ancemntSaveData(form_data))
    }
  }

  const handleEditAnnouncementType = (data) => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      announcementTitleId: data.announcementTitleId,
      announceId: data.announceId,
      announceName: data.announceTypeName,
      announceDesc: data.announceDesc,
      announceImage: null,
      announceIcon: data.announceIcon,
      isEnableFile: data.isEnableFile,
    }))
    setColor(data.colorCode)
  }

  const handleAnnouncementTypeModal = () => {

    dispatch(getAnnouncementTitle(getAnnouncementTitlePath))

    setCreateAnnType(true)
  }

  const handleAnnouncementTypeModalFalse = () => {
    setAnnouncementCreate((pre) => ({
      ...pre,
      userId: user.user_id,
      announcementTitleId: "",
      announceId: "",
      announceName: "",
      announceDesc: "",
      announceImage: null,
      announceIcon: "",
      isEnableFile: "1",
    }))
    setColor("")
    setColorError(false)
    setCreateAnnType(false)
    setValidated(false);
  }

  // main form submit ----------------
  const submitCancel = () => {

  }

  const submitDraftOrPublish = (type) => {
    const formData = {
      path: saveAnnouncementPath,
      data: {
        userId: user.user_id,
        announceId: announcementType,
        subject: annTypeSubject,
        subjectFlag: annTypeDataObj.subjectFlag,
        bodyContent: value,
        tagPeoples: selectedTagEmp.list.map((item) => item.value).toString(),
        tagGroups: annTypeDataObj.tagGroups,
        announceBanner: annTypeDataObj.announceBanner,
        reactionAllowId: annTypeDataObj.reactionAllowId,
        reactionDislikeId: annTypeDataObj.reactionDislikeId,
        commentId: annTypeDataObj.commentId,
        repliesId: annTypeDataObj.repliesId,
        approveComments: annTypeDataObj.approveComments,
        allowPushNotify: annTypeDataObj.allowPushNotify,
        pinTopFeed: annTypeDataObj.pinTopFeed,
        allowPublishNowOrLater: annTypeDataObj.allowPublishNowOrLater,
        scheduleDate: annTypeDataObj.scheduleDate,
        scheduleTime: annTypeDataObj.scheduleTime,
        visiblityId: annTypeDataObj.visiblityId,
        departmentId: annTypeDataObj.departmentId,
        isSaveDraft: type,
        attachements: files,
        supportingFile: annTypeDataObj.announceBanner,
        announcementTitleId: annTypeDataObj.announcementTitleId,
      }
    }
    dispatch(ancemntSaveData(formData))
  }

  useEffect(() => {
    if (announceStore.ancemntSuccess) {
      toast.success(announceStore.ancemntMessage)
      dispatch(initAncemntState())
      setAnnouncementCreate((pre) => ({
        ...pre,
        userId: user.user_id,
        announcementTitleId: "",
        announceId: "",
        announceName: "",
        announceDesc: "",
        announceImage: null,
        announceIcon: "",
        isEnableFile: "1",
      }))
      setColor("")
      setColorError(false)
      setCreateAnnType(false)
      if (isEditAnnType) {
        setIsEditAnnTypeSuccess(true)
        setIsEditAnnType(false)
      }
      // --------------------------------------------------------
      setAnnouncementType("")
      setAnnTypeSubject("")
      setValue("")
      setSelectedTagEmp((pre) => ({
        list: []
      }))
      setFiles([])
      setAnnTypeDataObj((pre) => ({
        ...pre,
        userId: user.user_id,
        announcementTitleId: "",
        announceId: "",
        subject: "",
        subjectFlag: "",
        bodyContent: "",
        tagPeoples: [],
        tagGroups: "",
        announceBanner: "",
        announceBnrPrev: "",
        reactionAllowId: "",
        reactionDislikeId: "",
        commentId: "",
        repliesId: "",
        approveComments: "",
        allowPushNotify: "",
        pinTopFeed: "",
        allowPublishNowOrLater: "",
        scheduleDate: "",
        scheduleTime: "",
        visiblityId: "",
        departmentId: "",
        isSaveDraft: "",
        attachements: ""
      }))
    }

    if (announceStore.ancemntSuccessOne) {
      setRecentDraftList(announceStore.ancemntDataOne)
      dispatch(initAncemntState())
    }

    if (announceStore.ancemntError) {
      toast.error(announceStore.ancemntMessage)
      dispatch(initAncemntState())
      setAnnouncementCreate((pre) => ({
        ...pre,
        userId: user.user_id,
        announcementTitleId: "",
        announceId: "",
        announceName: "",
        announceDesc: "",
        announceImage: null,
        announceIcon: "",
        isEnableFile: "1",
      }))
      setColor("")
      setColorError(false)
      setCreateAnnType(false)
    }

    if (announceStore.ancemntGetThirdSuccess) {
      const newArr = announceStore.ancemntGetThirdData?.map((item) => {
        return { value: item.staffId, label: item.fullName }
      })
      setTaggedEmpList(newArr)
      dispatch(initAncemntState())
    }

    if (announceStore.ancemntGetFourthSuccess) {
      const newArr = announceStore.ancemntGetThirdData?.map((item) => {
        return { value: item.staffId, label: item.fullName }
      })
      setTaggedEmpGroupList([])
      // setTaggedEmpGroupList(announceStore.ancemntGetFourthData)
      dispatch(initAncemntState())
    }

    if (announceStore.ancemntGetOneSuccess) {
      setDepartmentList(announceStore.ancemntGetOneData)
      dispatch(initAncemntState())
    }

    if (announceStore.ancmtTitleSuccess) {
      setAnnouncementTitleList(announceStore.ancmtTitleData)
    }
  }, [announceStore])

  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 1600,
      width: "340px",
    }),
    control: (provided, state) => ({
      ...provided,
      border: "1px solid gray",
      borderRadius: "12px !important",
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "#fff"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff",   // 👈 selected value text color
    }),
    input: (provided) => ({
      ...provided,
      color: "#fff",   // 👈 typing text color
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#aaa",   // 👈 placeholder text color
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "gray"
        : state.isSelected
          ? "#90caf9"
          : "#1e1d2e",
      color: "#fff",
      cursor: "pointer",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1e1d2e",
      color: "#fff"
    }),
  };

  const theme = themeStore.theme == "dark" ? customStyles : ""

  const goBack = () => {
    navigate("/notification")
  }

  return (
    <div className="add-notification-container">
      <div className="notification-header">
        <ul>
          {notiHeader.map((item) => (
            <li key={item.id}>
              <a href={`#${item.href}`}>
                <span className="step-num">{item.id}</span>
                <span>{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* 👇 yahan pe already CSS me scroll diya hoga */}
      <div className="notification-left-content" ref={containerRef}>

        <section className="noti-widget-bg mb-3" id="type">

          <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div className="d-flex align-items-center gap-2 color-white">
              <ArrowLeftLong class_name={"color-white cursor-pointer"} onClick={goBack} /> Back
            </div>


            <button type="button" className="universal-btn border-radius-8px" onClick={handleAnnouncementTypeModal}>
              <FiPlus /> <span style={{ position: "relative", top: "1px" }}>Add Announcement Type</span>
            </button>
          </div>

          {/* <div className="noti-widget-bg mt-3 padding-2rem"> */}
          <AnnouncemntTemplate selectTemplate={useTemplate} />
          {/* 
          </div> */}

          {/* ------------------------------------------------ useTemplate*/}
          <AnnouncementType
            announcementType={announcementType}
            handleAnnouncementTitleId={handleAnnouncementTitleId} 
            setAnnouncementType={setAnnouncementType}
            setAnnouncementTypeIcon={setAnnouncementTypeIcon}
            handleAnnTypeClicked={handleAnnTypeClicked}
            setIsEditAnnType={setIsEditAnnType}
            setCreateAnnType={setCreateAnnType}
            handleEditAnnouncementType={handleEditAnnouncementType}
            isEditAnnTypeSuccess={isEditAnnTypeSuccess}
            setIsEditAnnTypeSuccess={setIsEditAnnTypeSuccess}
          />
        </section>

        <section className="noti-widget-bg mb-3" id="subject">
          <h3 className="color-white">Add Subject</h3>
          <span className="color-gray font-14 mb-4">Enter a subject line for your announcement (optional for some types)</span>

          <h5 className="color-white font-weight-200 mt-4 mb-2">Subject Line</h5>
          <input
            name="annTypeSubject"
            value={annTypeSubject}
            onChange={handleAnnTypeSubject}
            className="universal-input"
            style={{ width: "100%" }}
            placeholder="Enter subject (optional for some types)" />

          <div className="d-flex align-items-center justify-content-start gap-4 mt-3">
            <Form.Group>
              <Form.Check name="subjectFlag" value={annTypeDataObj.subjectFlag} onChange={handleAnnTypeInputChange} label="Auto-generate subject based on type" className="color-gray font-14 font-weight-200" />
            </Form.Group>
            <Form.Group>
              <Form.Check label="Mark as urgent" className="color-gray font-14 font-weight-200" />
            </Form.Group>
          </div>

        </section>

        <section className="noti-widget-bg mb-3" id="content">
          <h3 className="color-white">Body Content</h3>
          <div className="d-flex align-items-center justify-content-between gap-2">
            <span className="color-gray font-14 mb-4">Create your announcement content with rich formatting options</span>
            <span><span className="color-gray font-14 mb-4">Character typed:</span><span className="color-white font-14 mb-4"> {descriptionCount}/250</span></span>
          </div>

          <ReactQuill
            theme="snow"
            value={value}
            onChange={handleSetValue}
            modules={editorModules}
            placeholder="Write your announcement content here..."
            className="color-white mt-4"
          />
          {/* <div className="mt-3 quick-template">
            <h4 className="color-white mb-3">Quick Templates</h4>
            <div className="templates">
              <div className="template">
                <h4 className="color-white">🎉 Festival Template</h4>
                <span className="color-gray font-weight-200 font-12">Wishing everyone a joyous celebration...</span>
              </div>
              <div className="template">
                <h4 className="color-white">🌟 Appreciation Template</h4>
                <span className="color-gray font-weight-200 font-12">We're proud to recognize outstanding work...</span>
              </div>
            </div>
          </div> */}
        </section>

        <section className="noti-widget-bg mb-3" id="tags">
          <h3 className="color-white">Tag People</h3>
          <span className="color-gray font-14 mb-4">Mention specific employees or teams (optional)</span>

          <h5 className="color-white mt-4 mb-2">Tag Employees</h5>
          {/* <input className="universal-input" style={{ width: "100%" }} placeholder="Type @ to mention employees..." /> */}

          <Select
            options={taggedEmpList}
            // isMulti
            value={selectedOptions}
            onChange={handleChangeTag}
            placeholder="Mention employee to tag..."
            // className="universal-input"
            classNamePrefix="custom"
            styles={theme}
          />
          {
            selectedTagEmp.list.length ?
              <h5 className="color-white mt-4 mb-2">Tagged People</h5> : null
          }

          <div className="d-flex align-items-center justify-content-start gap-2">
            {
              selectedTagEmp.list?.map((item) => {
                return <button type="button" className="tagged-people font-weight-200 color-white" key={item.value} onClick={() => handleRemoveTagEmp(item.value)}>
                  {item.label} <RxCross2 className="cross-purple" />
                </button>
              })
            }
          </div>
          {
            taggedEmpGroupList.length ?
              <h5 className="color-white  mt-4 mb-2">Quick Tag Groups</h5> : null
          }

          <div className="d-flex align-items-center justify-content-start gap-2">
            {
              taggedEmpGroupList?.map((item) => {
                return <button className="tagged-people-group font-weight-200 color-white">@everyone </button>
              })
            }

          </div>
        </section>

        <section className="noti-widget-bg mb-3" id="attach">
          <h3 className="color-white">Attachments</h3>
          <span className="color-gray font-14 mb-4">Upload images, documents, or other files (optional)</span>

          <div
            {...getRootProps()}
            // style={{
            //   background: isDragActive ? "#f0f8ff" : "#00000010",
            // }}
            className="dropzone mt-4"
          >
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drop the files here...</p>
            ) : (
              <div className="dropzone-inner-layout">
                <span> <FaCloudUploadAlt /> </span>
                <h3 className="mt-4 color-white font-weight-200">Drag & drop some files here</h3>
                <h5 className="mb-3 color-gray font-weight-200 font-14">or click to browse</h5>
                <h4 className="color-gray font-weight-200">Supports: PDF, DOC, EXCEL . Max size: 10MB</h4>
              </div>
            )}
          </div>

          {
            files && files.length ? files.map((file) => {
              const fileURL = URL.createObjectURL(file);
              return <div className="image-preview mt-4" key={file.name}>
                <div className="left-preview">
                  <span> <FaImage /> </span>
                  <div className="image-detail">
                    <h3 className="color-white font-weight-200">{file.name}</h3>
                    <h5 className="color-gray font-weight-200">{(file.size / (1024 * 1024)).toFixed(2)} MB Uploaded</h5>
                  </div>
                </div>
                <div className="right-preview">
                  <span> <a href={fileURL} target="_blank" rel="noopener noreferrer">
                    <IoEyeOutline className="see" />
                  </a> </span>
                  <span> <RiDeleteBinLine className="del" onClick={() => removeFile(file.name, file.size)} /> </span>
                </div>
              </div>
            }) : null
          }

          {
            annTypeData.isEnableFile == "1" ?
              <div className="photo-and-template mt-4">
                <div className="photo-template">
                  <h3 className="color-white font-weight-200"> <FaCamera className="camera" /> Upload Photo</h3>
                  <h5 className="color-gray font-weight-200 font-14 mt-2">For employee appreciation posts</h5>
                  <label type="button" className="up-photo mt-4" htmlFor="up-photo">Select Photo</label>
                  <input type="file" name="announceBanner" id="up-photo" onChange={uploadEmpPhoto} style={{ display: "none" }} />
                </div>
                {/* <div className="photo-template">
                  <h3 className="color-white font-weight-200"> <IoColorPaletteSharp className="design" /> Design Templates</h3>
                  <h5 className="color-gray font-weight-200 font-14 mt-2">Pre-made announcement designs</h5>
                  <label type="button" className="design-temp color-white mt-4" htmlFor="design-temp">Browse Templates</label>
                  <input type="file" id="design-temp" onChange={browseTemplate} style={{ display: "none" }} />
                </div> */}
              </div> : null
          }
        </section>

        <section id="settings" className="p-0">
          <div className="noti-widget-bg padding-2rem">
            <h3 className="color-white">Interaction Settings</h3>
            <span className="color-gray font-14 mb-4">Configure how employees can interact with this announcement</span>
            <h3 className="mt-4 color-white font-weight-200">Reaction</h3>
            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">

              <div className="d-flex align-items-center justify-content-between gap-2 react-reply">
                <div className="d-flex align-items-center justify-content-start gap-2">
                  <span className="like"> <FaThumbsUp /> </span>
                  <div className="d-flex flex-column align-items-start gap-1">
                    <h3 className="color-white font-weight-200">Allow Likes</h3>
                    <h5 className="color-gray font-weight-200 font-14">Let employees like this post</h5>
                  </div>
                </div>

                <div>
                  <Switch
                    name="reactionAllowId"
                    checked={annTypeDataObj.reactionAllowId === "1"}
                    onChange={(event) => handleAllowLike(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between gap-2 react-reply">
                <div className="d-flex align-items-center justify-content-start gap-2">
                  <span className="dislike"> <AiFillDislike /> </span>
                  <div className="d-flex flex-column align-items-start gap-1">
                    <h3 className="color-white font-weight-200">Allow Dislikes</h3>
                    <h5 className="color-gray font-weight-200 font-14">Let employees dislike this post</h5>
                  </div>
                </div>
                <div>
                  <Switch
                    name="allowreactionDislikeIdLike"
                    checked={annTypeDataObj.reactionDislikeId === "1"}
                    onChange={(event) => handleAllowDisLike(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div>

            </div>

            <h3 className="mt-4 color-white font-weight-200">Comments & Replies</h3>
            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">

              <div className="d-flex align-items-center justify-content-between gap-2 react-reply">
                <div className="d-flex align-items-center justify-content-start gap-2">
                  <span className="chat"> <BsChatFill /> </span>
                  <div className="d-flex flex-column align-items-start gap-1">
                    <h3 className="color-white font-weight-200">Allow Comments</h3>
                    <h5 className="color-gray font-weight-200 font-14">Let employees like this post</h5>
                  </div>
                </div>
                <div>
                  <Switch
                    name="commentId"
                    checked={annTypeDataObj.commentId === "1"}
                    onChange={(event) => handleCommentId(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between gap-2 react-reply">
                <div className="d-flex align-items-center justify-content-start gap-2">
                  <span className="reply"> <FaReply /> </span>
                  <div className="d-flex flex-column align-items-start gap-1">
                    <h3 className="color-white font-weight-200">Allow Replies</h3>
                    <h5 className="color-gray font-weight-200 font-14">Let employees dislike this post</h5>
                  </div>
                </div>
                <div>
                  <Switch
                    name="repliesId"
                    checked={annTypeDataObj.repliesId === "1"}
                    onChange={(event) => handleRepliesId(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
              </div>

            </div>

            {/* -------Advanced Option-------- */}
            <div className="d-flex align-items-center justify-content-between gap-2 react-reply mt-3">
              <div className="d-flex align-items-center justify-content-start gap-2">
                <div className="d-flex flex-column align-items-start gap-1">
                  <h3 className="color-white font-weight-200">Require approval for comments</h3>
                  <h5 className="color-gray font-weight-200 font-14">Comments need approval before appearing</h5>
                </div>
              </div>
              <div>
                <Switch
                  name="approveComments"
                  checked={annTypeDataObj.approveComments === "1"}
                  onChange={(event) => handleApprovalCmd(event.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 react-reply mt-3">
              <div className="d-flex align-items-center justify-content-start gap-2">
                <div className="d-flex flex-column align-items-start gap-1">
                  <h3 className="color-white font-weight-200">Send push notifications</h3>
                  <h5 className="color-gray font-weight-200 font-14">Notify all tagged employees immediately</h5>
                </div>
              </div>
              <div>
                <Switch
                  name="allowPushNotify"
                  checked={annTypeDataObj.allowPushNotify === "1"}
                  onChange={(event) => handleAllowPushNotify(event.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 react-reply mt-3">
              <div className="d-flex align-items-center justify-content-start gap-2">
                <div className="d-flex flex-column align-items-start gap-1">
                  <h3 className="color-white font-weight-200">Pin to top of feed</h3>
                  <h5 className="color-gray font-weight-200 font-14">Keep this announcement at the top</h5>
                </div>
              </div>
              <div>
                <Switch
                  name="pinTopFeed"
                  checked={annTypeDataObj.pinTopFeed === "1"}
                  onChange={(event) => handlePinTopFeed(event.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
            </div>

          </div>

          <div className="noti-widget-bg mt-3 padding-2rem">
            <h3 className="color-white">Publishing Options</h3>
            <span className="color-gray font-14 mb-4">Choose when and how to publish your announcement</span>

            <Row>


              <Col sm="6">
                <h3 className="mt-4 color-white font-weight-200 mt-3 mb-3">Schedule Publishing</h3>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Check name="allowPublishNowOrLater" type="radio" onChange={handleAnnTypeInputChange} label="Publish Now" className="color-white" />
                  </Form.Group>
                </Col>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Check name="allowPublishNowOrLater" type="radio" onChange={handleAnnTypeInputChange} label="Schedule for later" className="color-white" />
                  </Form.Group>
                </Col>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Label className="color-white">Date</Form.Label>
                    <Form.Control type="date" name="scheduleDate" value={annTypeDataObj.scheduleDate} onChange={handleAnnTypeInputChange} className="universal-input" />
                  </Form.Group>
                </Col>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Label className="color-white">Time</Form.Label>
                    <Form.Control type="time" name="scheduleTime" value={annTypeDataObj.scheduleTime} onChange={handleAnnTypeInputChange} className="universal-input" />
                  </Form.Group>
                </Col>
              </Col>


              <Col sm="6">
                <h3 className="mt-4 color-white font-weight-200 mt-3 mb-3">Visibility</h3>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Check type="radio" name="visiblityId" value={1} onChange={handleAnnTypeInputChange} label="Everyon in company" className="color-white" />
                  </Form.Group>
                </Col>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Check type="radio" name="visiblityId" value={2} onChange={handleAnnTypeInputChange} label="Specific Departments" className="color-white" />
                  </Form.Group>
                </Col>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Check type="radio" name="visiblityId" value={3} onChange={handleAnnTypeInputChange} label="Only Tagged people" className="color-white" />
                  </Form.Group>
                </Col>
                <Col sm="12" className="mt-2">
                  <Form.Group>
                    <Form.Label className="color-white">Select Department</Form.Label>
                    <Form.Select className="universal-input" name="departmentId" value={annTypeDataObj.departmentId} onChange={handleAnnTypeInputChange}>
                      <option>Select Department</option>
                      {
                        departmentList?.map((item) => {
                          return <option key={item.departmentId}>{item.department_name}</option>
                        })
                      }

                    </Form.Select>
                  </Form.Group>
                </Col>
              </Col>
            </Row>
          </div>

          {
            recentDraftList ? <div className="noti-widget-bg mt-3 padding-2rem">
              <h3 className="color-white mb-3">Recent Draft</h3>
              <Row>

                {
                  recentDraftList?.map((item, idx) => {
                    return <Col sm="4" className="p-1">
                      <div className="react-reply height-220 d-flex flex-column justify-content-between gap-2">
                        <div className="d-flex align-items-center justify-content-between gap-2">
                          <span className="font-30"><img src={birthday} /></span>
                          <span className="color-gray">2 hours ago</span>
                        </div>
                        <div>
                          <h3 className="color-white mb-2 mt-2 font-weight-200">{item.subject}</h3>
                          <h5 className="color-gray font-weight-200" dangerouslySetInnerHTML={{ __html: item.bodyContent }}></h5>
                        </div>
                        <div className="d-flex align-items-center justify-content-between gap-2 mt-2">
                          <span className="birthday">Birthday</span>
                          <span className="reply"><PiPencilSimpleLine /> </span>
                        </div>
                      </div>
                    </Col>
                  })
                }

                {/* <Col sm="4" className="p-1">
                <div className="react-reply height-220 d-flex flex-column justify-content-between gap-2">
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="font-30"><img src={sales} /></span>
                    <span className="color-gray">1 day ago</span>
                  </div>
                  <div>
                    <h3 className="color-white mb-2 mt-2 font-weight-200">Q4 Results Announcement</h3>
                    <h5 className="color-gray font-weight-200">Excited to share our quarterly achievements...</h5>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-2 mt-2">
                    <span className="sales">Sales</span>
                    <span className="reply"><PiPencilSimpleLine /> </span>
                  </div>
                </div>
              </Col>

              <Col sm="4" className="p-1">
                <div className="react-reply height-220 d-flex flex-column justify-content-between gap-2">
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="font-30"><img src={onbording} /> </span>
                    <span className="color-gray">3 days ago</span>
                  </div>

                  <div>
                    <h3 className="color-white mb-2 mt-2 font-weight-200">New Employee Welcome</h3>
                    <h5 className="color-gray font-weight-200">Please join me in welcoming our new team member...</h5>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2 mt-2">
                    <span className="onboarding">Onboarding</span>
                    <span className="reply"><PiPencilSimpleLine /> </span>
                  </div>
                </div>
              </Col> */}
              </Row>

            </div> : null
          }

          <div className="noti-widget-bg d-flex align-items-center justify-content-between mt-3">
            <div className="color-white">
              <span> <FaSave /> </span> &nbsp;
              <span>Auto saved 2 minuts ago</span>
            </div>

            <div className="d-flex align-items-center justify-content-start gap-2">
              <button type="button" onClick={submitCancel} className="universal-sec-btn border-radius-8px"> Cancel </button>
              <button type="button" onClick={() => submitDraftOrPublish("1")} className="universal-sec-btn border-radius-8px"> <FaFileLines /> Save as draft</button>
              <button type="button" onClick={() => submitDraftOrPublish("2")} className="universal-btn border-radius-8px"> <GrSend className="send-icon" /> Publish Announcement</button>
            </div>
          </div>
        </section>
      </div>

      <div className="notification-right-content">
        <LivePreview
          icon={announcementTypeIcon}
          annTypeData={annTypeData}
          subject={annTypeSubject}
          anntypeDes={value}
          selectedTagEmp={selectedTagEmp.list}
          banner={annTypeDataObj.announceBnrPrev}
          reactionAllowId={annTypeDataObj.reactionAllowId}
          reactionDislikeId={annTypeDataObj.reactionDislikeId}
          commentId={annTypeDataObj.commentId}
          repliesId={annTypeDataObj.repliesId}
          approveComments={annTypeDataObj.approveComments}
        />
        <QuickStatus selectedTagEmp={selectedTagEmp.list.length} descriptionCount={descriptionCount} />
      </div>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={createAnnType}
        onClose={handleAnnouncementTypeModalFalse}
        className="dark-bg-color"
      >

        <Form noValidate validated={validated} onSubmit={submitCreateAnnouncementType} enctype="multipart/form-data">
          <DialogTitle className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={handleAnnouncementTypeModalFalse}>
                X
              </span>
              <span className="title">
                {isEditAnnType ? "Update Announcement" : "Create Announcement"}
              </span>
            </div>
            <button
              className="universal-btn"
              style={{ padding: "0 15px", borderRadius: "8px", fontSize: "15px" }}
              type="submit"
            >
              {isEditAnnType ? "Update" : "Create"}
            </button>
          </DialogTitle>
          <DialogContent>

            <Row className="mt-3">

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Announcment Title</Form.Label>
                  <Form.Select
                    name={"announcementTitleId"}
                    value={announcementCreate.announcementTitleId}
                    onChange={handleAnnouncementTitle}
                    className="universal-input"
                    required
                  >
                    <option value={""}>Select Announcement Title</option>
                    {
                      announcementTitleList.map(list => {
                        return <option value={list.announcementTitleId} key={list.announcementTitleId}>
                          {
                            list.announcementTitleName
                          }
                        </option>
                      })
                    }
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    Announcement type is requird
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>


              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Announcment Type</Form.Label>
                  <Form.Control
                    name={"announceName"}
                    value={announcementCreate.announceName}
                    placeholder={"Enter Announcment Type here"}
                    onChange={handleCreateAnnouncementType}
                    className="universal-input"
                    readOnly
                    required
                  />

                  <Form.Control.Feedback type="invalid">
                    Announcement type is requird
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Announcment Description</Form.Label>
                  <Form.Control
                    name={"announceDesc"}
                    value={announcementCreate.announceDesc}
                    placeholder={"Enter asserts id here"}
                    onChange={handleCreateAnnouncementType}
                    className="universal-input"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Announcement description is requird
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Upload File</Form.Label>
                  <Form.Control
                    type="file"
                    name={"announceImage"}
                    onChange={handleAnnFileChange}
                    className="universal-input"
                    required={isEditAnnType ? false : true}
                  />
                  <Form.Control.Feedback type="invalid">
                    Announcement image is requird
                  </Form.Control.Feedback>
                </Form.Group>

                {
                  announcementCreate.announceIcon ? <img src={announcementCreate.announceIcon} width={"150px"} height={"150px"} /> : null
                }
              </Col>

              <Col sm="12" className="flex-column color-white mt-3">
                <Form.Group>
                  <Form.Label className="color-white">Color Code</Form.Label>
                  <HexColorPicker color={color} onChange={handleColorCode} style={{ width: "100%", height: "200px" }} />
                  {
                    colorError ? <span style={{ color: "red" }} className="font-13">
                      Color code is requird
                    </span> : null
                  }

                </Form.Group>
              </Col>

              <Col sm="12" className="mt-2">
                <Form.Group>
                  <Form.Label className="color-white">If you want Enable Photo?</Form.Label>
                  <Switch
                    name="isEnableFile"
                    checked={announcementCreate.isEnableFile === "1"} // string ko boolean banaya
                    onChange={(event) => handleAnnIsFileEnable(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </DialogContent>
        </Form>
      </Dialog>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default AddNotification;